import { Alert } from "react-bootstrap";
import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import TitleSlide from "../../components/Slides/templates/TitleSlide";
import StudentPicker from "../../components/global/StudentPicker";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";
import CodeSlide from "../../components/Slides/templates/CodeSlide";
import { useEffect, useRef } from "react";
import "./S04P01.css";

interface ToastifyOptions {
  text: string;
  duration?: number;
  newWindow?: boolean;
  close?: boolean;
  gravity?: "top" | "bottom";
  position?: "left" | "center" | "right";
  stopOnFocus?: boolean;
  style?: Record<string, string>;
  onClick?: () => void;
}

declare function Toastify(options: ToastifyOptions): { showToast: () => void };

export default function S05P01({ reveal }: ISlideObject) {
  useEffect(() => {
    window.addEventListener("offline", () => {
      Toastify({
        text: "Parece que estás offline 😢",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top", // `top` or `bottom`
        position: "left", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
          background: "linear-gradient(to right,rgb(176, 0, 67),rgb(57, 2, 2))",
        },
        onClick: function () {}, // Callback after click
      }).showToast();
    });
    window.addEventListener("online", () => {
      Toastify({
        text: "Vuelves a estar online 😃",
        duration: 3000,
        newWindow: true,
        close: true,
        gravity: "top", // `top` or `bottom`
        position: "left", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
          background: "linear-gradient(to right, #00b09b, #96c93d)",
        },
        onClick: function () {}, // Callback after click
      }).showToast();
    });
  }, []);

  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 05 Parte 1"
      />
      <DefaultSlide title="Agenda">
        <div>
          <ul>
            <li>
              Exposición de 10 minutos sobre la presentación del laboratorio 1.
            </li>
            <li>Overview del proyecto #1.</li>
            <li>Generando tareas y un prototipo para un proyecto web.</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <TitleSlide
          title="Laboratorio 01"
          subtitle="Presentación de los laboratorios"
        />
      </section>
      <section>
        <TitleSlide title="Generalidades del proyecto 01" />
        <section>
          <p>¿qué les parece el proyecto? ¿útil, real?</p>
        </section>
        <section>
          <p>
            Cada equipo tiene el mismo nivel de complejidad, pero aplicado de
            formas distintas.
          </p>
          <p className="fragment">
            Sacar cita conmigo para ampliar en requerimientos y entender mejor
            el proyecto.
          </p>
          <p className="fragment">Disponibilidad Viernes 21 de Marzo.</p>
        </section>
        <section>
          <p>Aclaración sobre la defensa del proyecto.</p>
          <p>
            La distribución de la defensa es análoga en valor a los entregables
            del proyecto. Por cada entregable se realizarán preguntas de forma
            aleatoria que todas las personas del equipo deben tener la capacidad
            de responder.
          </p>
        </section>
      </section>
      <section>
        <TitleSlide title="Generando tareas y un prototipo para un proyecto web" />
        <DefaultSlide title="Hablemos de desarrollo ágil">
          <div>
            <p>
              Ustedes han visto el mundo de la gestión de proyectos en otros
              cursos.
            </p>
            <p>
              ¿Cuál es la mejor estrategia de gestión a utilizar para un equipo?
            </p>
          </div>
        </DefaultSlide>
        <section>
          <img src="/images/S05/scrum.png" alt="" />
        </section>
        <DefaultSlide title="Factores a tomar en cuenta">
          <div>
            <ul>
              <li>Tamaño del equipo.</li>
              <li>Complejidad del proyecto.</li>
              <li>Plazos y restricciones de tiempo.</li>
              <li>Experiencia previa del equipo.</li>
              <li>Disponibilidad de recursos.</li>
              <li>Expectativas del cliente o stakeholders.</li>
              <li>Flexibilidad requerida en los entregables.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Qué es lo mejor para nuestro proyecto?">
          <div>
            <p>¿Qué metodología de trabajo es mejor para el proyecto?</p>
            <p>¿Scrum? ¿Kanban? ¿XP?</p>
            <p>
              ¿Cómo se pueden generar tareas y un prototipo para un proyecto
              web?
            </p>
            <p>
              ¿Qué herramientas se pueden utilizar para gestionar el proyecto?
            </p>
            <p>
              ¿Qué herramientas se pueden utilizar para generar un prototipo?
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Qué es lo mejor para nuestro proyecto?">
          <div>
            <p>
              Como profesionales en TI ustedes tienen que saber encontrar el
              mejor sabor para su proyecto, empresa, organización.
            </p>
            <p>
              No hay una única forma de hacer las cosas, pero si hay mejores
              prácticas.
            </p>
            <p>
              En PYMES y organizaciones pequeñas <strong>por lo general</strong>{" "}
              se adaptan mejor a estrategias ágiles de gestión de proyectos.
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="¿Qué es lo mejor para nuestro proyecto?">
          <div>
            <p>
              Vamos a utilizar un sabor personalizado de metodologías ágiles.
            </p>
            <img
              src="/images/S05/metodologia.png"
              alt="Metodologia Scrum a utilizar en el proyecto"
              width={400}
            />
          </div>
        </DefaultSlide>
        <section>
          <img
            src="/images/S05/metodologia.png"
            alt="Metodologia Scrum a utilizar en el proyecto"
          />
        </section>
        <DefaultSlide title="Plan del proyecto">
          <div>
            <p>
              En la especificación del proyecto se encuentra la plantilla del
              plan del proyecto.
            </p>
            <p>
              Incluye el segundo punto de la metodología que es la lista
              preliminar del backlog
            </p>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Ejemplo de backlog preliminar">
          <div>
            <ul>
              <li>
                Como usuario principal, puedo visualizar una lista de canciones
                de un artista ordenadas por fecha de lanzamiento.
              </li>
              <li>
                Como usuario principal, puedo cambiar el orden de la
                visualización por los criterios: fecha de lanzamiento, duración
                y calificación.
              </li>
              <li className="fragment">
                Estas no son realmente historias de usuario formalmente.
              </li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Prototipo básico">
          <div>
            <p>
              Pueden utilizar cualquier herramienta de prototipo que les permita
              compartir el diseño con el profesor.
            </p>
            <div style={{ display: "flex", gap: "1rem" }}>
              <img src="/images/S05/draw.png" alt="Draw.io icon" width={200} />
              <img src="/images/S05/figma.jpg" alt="figma icon" width={200} />
              <img src="/images/S05/sketch.jpg" alt="Sketch icon" width={200} />
            </div>
          </div>
        </DefaultSlide>
        <section>
          <p>Veamos un ejemplo con draw.io</p>
        </section>
        <DefaultSlide title="Backlog en tool de gestión">
          <div>
            <p>Utilizaremos planner para gestionar este proyecto.</p>
            <div style={{ display: "flex", gap: "1rem" }}>
              <img
                src="/images/S05/planner.png"
                alt="planner screenshot"
                width={800}
              />
            </div>
          </div>
        </DefaultSlide>
      </section>
      <ImageSlide
        image="/images/S05/dancing5.gif"
        title="Fin de parte 1"
      />
    </>
  );
}
